// Generic automation and intervals actions related to Pixlee galleries go in this concern

Pixlee.module('Concerns', function(Concerns, App, Backbone, Marionette, $) {
    Concerns.intervalHelpers = {
        onShow: function() {
            var receiveMessage = function(event) {
                var eventData;
                if (!event.data) {
                    return;
                } else {
                    try {
                        eventData = JSON.parse(event.data);
                    } catch (error) {
                        // Some other way of sending data, ignore
                        return;
                    }
                }

                if (eventData.name && eventData.name === 'pixlee:enable:gallery:hover:interval') {
                    this.enableHoverInterval();
                }
            }.bind(this);
            window.addEventListener('message', receiveMessage, false);
        },
        // Randomly "hover" a photo block in the given gallery every 5 seconds. Currently used for Puma's in-store displays
        enableHoverInterval: function() {
            if (this.hoverInterval) {
                return;
            }
            var activePhotoblock;
            this.hoverInterval = setInterval(function() {
                if (activePhotoblock) {
                    activePhotoblock.$el.removeClass('hover_effect');
                }
                // get random photo block child of collection view
                activePhotoblock = Object.values(this.children._views)[Math.floor(Math.random() * this.collection.length)];
                activePhotoblock.$el.addClass('hover_effect');
            }.bind(this), 5000 + _.random(0, 3000));
        },
    };
});
